/* @flow */
import React from 'react';

import CurrentUser from 'auth/CurrentUser';
import LeadStore from 'stores/LeadStore';
import { mountModal } from 'lib/modal';
import PromptActions from 'actions/PromptActions';
import { PromptNames } from 'constants/PromptConstants';
import PromptStore from 'stores/PromptStore';
import TymkModal from 'user/components/TymkModal.jsx';
import SetupActions from 'actions/SetupActions';

function isTymkPromptEnabled(): boolean {
  return CurrentUser.isSignedIn() &&
    CurrentUser.getUser().hasItemInPromptsInventory(PromptNames.TYMK_MODAL) &&
    !PromptStore.hasDismissed(PromptNames.TYMK_MODAL);
}

type TymkContext =
  'download_pdf' |
  'send_invite' |
  'send_chat' |
  'send_announcement' |
  'onboarding';

// typecheck: ignore statement
export default function mountTymkPrompt(parent: React$Component<any, any, any>, context: TymkContext, hideOnBlur: boolean = false) {
  const leads = LeadStore.getLeads();
  if (!isTymkPromptEnabled() || leads.length === 0) {
    return;
  }

  PromptActions.recordDismissal(PromptNames.TYMK_MODAL);
  SetupActions.removeFlagsForSetupSession();

  const modal = (
    <TymkModal
      leads={leads}
      triggeredContext={context}
      onRequestHide={() => {}}
      hideOnBlur={hideOnBlur}
    />
  );
  // Delay showing the tymk modal by half a second
  setTimeout(() => {
    mountModal(modal, parent);
  }, 500);
}



// WEBPACK FOOTER //
// ./src/utils/mountTymkPrompt.js